import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';

// A cell value shown as a Bootstrap badge - built through GridService.badge(). The column passes
// badgeClass (the colour classes for a value) and, optionally, label (the text a person reads).
@Component({
  selector: 'app-badge-renderer',
  templateUrl: './badge-renderer.component.html',
  styleUrl: './badge-renderer.component.scss',
})
export class BadgeRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  protected get badgeClass(): string {
    return this.params?.badgeClass?.(this.params.value) ?? 'text-bg-secondary';
  }

  protected get label(): string {
    return this.params?.label ? this.params.label(this.params.value) : (this.params?.value ?? '');
  }
}
